import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-092bdb10"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "x-modal x-modal__account" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "x-modal__container" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "x-modal__header" }, [
  /*#__PURE__*/_createElementVNode("p", null, "设置Samba")
], -1))
const _hoisted_5 = { class: "x-modal__content" }
const _hoisted_6 = { class: "form" }
const _hoisted_7 = { class: "form-item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "item-label" }, "用户名", -1))
const _hoisted_9 = { class: "form-item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "item-label" }, "密码", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icomoon-close icon-close" }, null, -1))
const _hoisted_12 = [
  _hoisted_11
]

import { ref } from 'vue'
interface IProps {
  mask?: boolean
  closeOnMaskClick?: boolean
  username: string
  password: string
}
interface IEmits {
  (e: 'confirm', data: Pick<IProps, 'username' | 'password'>): void
  (e: 'cancel'): void
  (e: 'close'): void
}

export default /*#__PURE__*/_defineComponent({
  props: {
    mask: { type: Boolean, default: true },
    closeOnMaskClick: { type: Boolean, default: false },
    username: null,
    password: null
  },
  emits: ["confirm", "cancel", "close"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'confirm', data: Pick<IProps, 'username' | 'password'>): void
  (e: 'cancel'): void
  (e: 'close'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { mask: boolean, closeOnMaskClick: boolean, username: string, password: string }


const username = ref(props.username)
const password = ref(props.password)



function onClose () {
  emits('close')
}
function onMaskClick () {
  if (!props.closeOnMaskClick) return
  onClose()
}
function onCancel () {
  emits('cancel')
}
function onConfirm () {
  const data = {
    username: username.value,
    password: password.value,
  }
  emits('confirm', data)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", _hoisted_1, [
      (__props.mask)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "x-modal__mask",
            onClick: _withModifiers(onMaskClick, ["self"])
          }, null, 8, _hoisted_2))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _withDirectives(_createElementVNode("input", {
                class: "item-input",
                placeholder: "请输入用户名",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((username).value = $event))
              }, null, 512), [
                [
                  _vModelText,
                  username.value,
                  void 0,
                  { lazy: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _withDirectives(_createElementVNode("input", {
                class: "item-input",
                placeholder: "请输入密码",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event))
              }, null, 512), [
                [
                  _vModelText,
                  password.value,
                  void 0,
                  { lazy: true }
                ]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", { class: "x-modal__footer" }, [
          _createElementVNode("div", { class: "operations" }, [
            _createElementVNode("button", {
              class: "operation impt",
              onClick: onConfirm
            }, " 确定 "),
            _createElementVNode("button", {
              class: "operation light",
              onClick: onCancel
            }, " 取消 ")
          ])
        ]),
        _createElementVNode("div", {
          class: "x-modal__close",
          onClick: onClose
        }, _hoisted_12)
      ])
    ])
  ]))
}
}

})